<div class="notification-message">
  <div class="content">
    @if (shouldShowDate()) {
      <p class="date">{{ getDate() }}</p>
    }
    <h3 class="title">{{ getCropFieldName() }}</h3>
    <p class="description">{{ 'TGA.Notifications.Messages.' + notification().type + '.Description' | translate }}</p>
  </div>
  <button mat-icon-button class="arrow-button" (click)="onArrowClick()">
    <mat-icon>arrow_forward</mat-icon>
  </button>
</div>
